export const COURSE_FIELD_LIMITS = {
  courseTitle: 100,
  courseDescription: 500,
  price: 25,
};

export const clampCourseFieldValue = (fieldName, value) => {
  const limit = COURSE_FIELD_LIMITS[fieldName];
  if (!limit) return value;
  return String(value || '').slice(0, limit);
};

export const getCourseFieldCharacterCount = (fieldName, value) => {
  const limit = COURSE_FIELD_LIMITS[fieldName];
  const used = String(value || '').length;

  if (!limit) {
    return {
      used,
      limit: null,
      remaining: null,
    };
  }

  return {
    used,
    limit,
    remaining: Math.max(0, limit - used),
  };
};
